<script setup lang="ts">
import type { Schemas } from "#shopware";
import {addToCartTracking} from "~/components/utilities/GtmTrackings";

const { pushSuccess, pushError } = useNotifications();
const props = defineProps<{
  products: any;
}>();
const { products } = toRefs(props);
const { getErrorsCodes } = useCartNotification();
const { t } = useI18n();
const miniCartController = useModal();

const addToCartProxy = async () => {
  for (const product of products.value) {
    const { addToCart, quantity } = useAddToCart(product);
    addToCartTracking(product, quantity.value);
    await addToCart();
    getErrorsCodes()?.forEach((element) => {
      pushError(t(`errors.${element.messageKey}`, { ...element }));
    });
  }
  miniCartController.open();
  /*pushSuccess(`<b>${product?.translated?.name}</b>` + t("product.messages.addedToCart"),);*/
};

const loading = ref(true);
onMounted(() => {
  loading.value = false;
});
</script>

<template>
  <SharedModal :controller="miniCartController" popup-class="checkout-side-cart" size="modal-xl">
    <CheckoutSideCart
        class="mini-cart"
        :controller="miniCartController"
        @close="miniCartController.close"
        @success="miniCartController.close"
        :successMessage="`<b>` + $t('product.product') + `</b>` + $t('product.messages.addedToCart')"
    />
  </SharedModal>

  <div class="product__actions-inner">
    <button
        class="btn btn-default btn-primary product__btn"
        data-testid="add-to-cart-button"
        :disabled="loading"
        @click="addToCartProxy">
      {{ $t("product.addBundleToCart") }}
    </button>
  </div>
</template>
